import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class GrammarCheckService {
  private apiUrl = 'https://api.languagetoolplus.com/v2/check'; // Example API URL, adjust based on the actual API you choose

  constructor(private http: HttpClient) { }

  checkGrammar(text: string) {
    const body = {
      text: text,
      language: 'en-US'
    };
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    // Note: Actual API parameters and headers will vary. Refer to the chosen API's documentation.
    return this.http.post(this.apiUrl, JSON.stringify(body), { headers: headers });
  }
}
